export enum DrawingType {
    OneUp = 'OneUp',
    Layout = 'Layout',
    Dieboard = 'Dieboard'
}
